import api from "./api";

export const getsPeriodoView = async (filters = {}) => {
    // El periodo no tiene filial: es comun a todas las sedes.
    const response = await api.get('/Periodo/GetsPeriodoView?'
            + 'idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&idEstadoApertura=' + (filters.idEstadoApertura == null ? 0 : filters.idEstadoApertura)
            + '&mesesHaciaAtras=' + (filters.mesesHaciaAtras == null ? 0 : filters.mesesHaciaAtras)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

// Cierra un periodo abierto. Lo concede el acceso periodo.cerrar.
export const verificarCierrePeriodo = (idPeriodo) =>
    api.get("/Periodo/VerificarCierrePeriodo?idPeriodo=" + idPeriodo);

export const cerrarPeriodo = (idPeriodo) =>
    api.post("/Periodo/CerrarPeriodo?idPeriodo=" + idPeriodo);

export const annulPeriodo = (idPeriodo) =>
    api.post("/Periodo/AnnulPeriodo?idPeriodo=" + idPeriodo);

export const activePeriodo = (idPeriodo) =>
    api.post("/Periodo/ActivePeriodo?idPeriodo=" + idPeriodo);

export const addUpdatePeriodo = (dataPost) =>
    api.post("/Periodo/AddUpdatePeriodo", dataPost);

export default {
    getsPeriodoView,
    annulPeriodo,
    activePeriodo,
    cerrarPeriodo,
    verificarCierrePeriodo,
    addUpdatePeriodo,
};
